// Note: There are companion query values in CSS in tailwind.config.js
const isDesktopQuery = { query: "(min-width: 1100px)" };
export const isDeviceQuery = { query: "(max-width: 1099px)" };
export const isTabletQuery = { query: "(min-width: 700px) and (max-width: 1099px)" };
export const isMobileQuery = { query: "(max-width: 699px)" };
export const isTabletOrLargerQuery = { query: "(min-width: 768px)" };
export default isDesktopQuery;
